import React from 'react'
import { DomainTableCell, DomainTableRow } from '../Steps.styled'
import { DomainTableColumn } from '../../CrossSaleModal.types'
import { DomainHeaderContent } from './DomainTableHeaderCell'

interface TableHeaderProps {
  columns: DomainTableColumn[]
  allSelectedByAccessor: (accessor: string) => boolean
  changeAllByAccessor: (accessor: string) => () => void
  selectedDomainsLimitReached: boolean
  moreDomainsThanAllowed: boolean
}

export const TableHeader = ({
  columns,
  allSelectedByAccessor,
  changeAllByAccessor,
  selectedDomainsLimitReached,
  moreDomainsThanAllowed,
}: TableHeaderProps) => {
  return (
    <DomainTableRow isHeader>
      {columns.map((cell, indx) => (
        <DomainTableCell
          flexStart={cell.flexStart}
          css={{ flex: cell.flex }}
          key={cell.accessor}
          isPadded={columns.length === indx + 1}
        >
          <DomainHeaderContent
            cellType={cell.accessor}
            status={allSelectedByAccessor(cell.accessor)}
            onClick={changeAllByAccessor(cell.accessor)}
            isSelectionDisabled={selectedDomainsLimitReached || moreDomainsThanAllowed}
          />
        </DomainTableCell>
      ))}
    </DomainTableRow>
  )
}
